var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('tabela-repeticao',{staticClass:"tabela-historico-parametros",attrs:{"somente-visualizacao":true,"colunas":_vm.colunas},scopedSlots:_vm._u([{key:"visualizacao",fn:function(ref){
var ref_slotScope = ref.slotScope;
var key = ref_slotScope.key;
var valor = ref_slotScope.valor;
return [_c('div',[_vm._v(" "+_vm._s(valor)+" ")])]}}]),model:{value:(_vm.parametros),callback:function ($$v) {_vm.parametros=$$v},expression:"parametros"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }